import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
  selector: 'app-include-exclude-having-toggle',
  templateUrl: './include-exclude-having-toggle.component.html',
  styleUrls: ['./include-exclude-having-toggle.component.scss']
})
export class IncludeExcludeHavingToggleComponent {
  /**
   * The text to display after "any/all of these {{forTypeText}}"
   */
  @Input() forTypeText: string;
  @Input() targetType = 'EntityType';

  @Input() operator: string;
  @Output() operatorChange = new EventEmitter<string>();

  @Input() hideAnyOrAll = false;
  @Input() lockIncludeExclude = false;


  get isInclude() {
    return this.operator?.includes('include');
  }

  get isAny() {
    return this.operator?.includes('any');
  }

  get targetTypeText() {
    if (this.targetType === 'EntityConnectionType') {
      return 'connections';
    }
    return 'entities';
  }

  /**
   *
   */
  constructor(private _cd: ChangeDetectorRef) {
  }


  toggleIncludes(shouldInclude: boolean) {
    if (shouldInclude) {
      this.operator = this.operator.replace('include', 'exclude');
    } else {
      this.operator = this.operator.replace('exclude', 'include');
    }
    this._cd.markForCheck();
    this.operatorChange.emit(this.operator);
  }

  toggleAny(isAny: boolean) {
    if (isAny) {
      this.operator = this.operator.replace('all', 'any');
    } else {
      this.operator = this.operator.replace('any', 'all');
    }
    this.operatorChange.emit(this.operator);
  }
}
